module.exports = __webpack_public_path__ + "home_performance.1afc50c313e5bbd838e7.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_performance.png
// module id = ../../../../../src/assets/img/home_performance.png
// module chunks = styles